import React from 'react';
import { Badge, Popover, List, Button, Typography, Empty } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useGetUnreadCountQuery, useListNotificationsQuery, useMarkReadMutation } from './notificationsApi';

const { Text } = Typography;

export default function NotificationBell() {
  const navigate = useNavigate();
  const { data: unreadData } = useGetUnreadCountQuery();
  const { data: notifData } = useListNotificationsQuery({ limit: 5 });
  const [markRead] = useMarkReadMutation();

  const notifications = notifData?.items || [];
  const unreadCount = unreadData?.count || 0;

  const content = (
    <div style={{ width: 340, maxWidth: '92vw', background: 'var(--df-surface-elevated)' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 16px',
          borderBottom: '1px solid var(--df-border)',
        }}
      >
        <Text strong style={{ fontSize: 13, color: 'var(--df-text)', fontFamily: 'var(--df-font-display)' }}>
          Notifications
        </Text>
        <Text style={{ fontSize: 12, color: 'var(--df-text-muted)' }}>
          {unreadCount} unread
        </Text>
      </div>
      {notifications.length === 0 ? (
        <div style={{ padding: 20 }}>
          <Empty description="No new notifications" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      ) : (
        <List
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item
              style={{
                background: item.readAt ? 'transparent' : 'rgba(11, 58, 92, 0.06)',
                padding: '12px 16px',
                cursor: 'pointer',
                borderBottom: '1px solid var(--df-border-subtle)',
                transition: 'background 0.15s var(--df-ease)',
              }}
              onClick={() => {
                if (!item.readAt) markRead(item.publicId);
                if (item.actionUrl) window.location.href = item.actionUrl;
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (!item.readAt) markRead(item.publicId);
                  if (item.actionUrl) window.location.href = item.actionUrl;
                }
              }}
              role="button"
              tabIndex={0}
            >
              <List.Item.Meta
                title={(
                  <Text style={{
                    fontSize: 13,
                    fontWeight: item.readAt ? 400 : 600,
                    color: 'var(--df-text)',
                  }}
                  >
                    {item.title}
                  </Text>
                )}
                description={(
                  <Text style={{ fontSize: 11, color: 'var(--df-text-muted)' }}>
                    {item.createdAt ? new Date(item.createdAt).toLocaleDateString() : ''}
                  </Text>
                )}
              />
            </List.Item>
          )}
        />
      )}
      {notifications.length > 0 && (
        <div style={{ padding: '10px 16px', borderTop: '1px solid var(--df-border)' }}>
          <Button
            type="link"
            size="small"
            style={{ padding: 0, fontWeight: 600, color: 'var(--df-primary)', minHeight: 36 }}
            onClick={() => navigate('/notifications')}
          >
            View all notifications
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomRight">
      <button
        type="button"
        aria-label={`Notifications${unreadCount ? `, ${unreadCount} unread` : ''}`}
        style={{
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          width: 44,
          height: 44,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 8,
          padding: 0,
        }}
      >
        <Badge count={unreadCount} size="small" offset={[-2, 2]} style={{ background: 'var(--df-accent)' }}>
          <BellOutlined style={{ fontSize: 18, color: 'rgba(244, 247, 250, 0.85)' }} />
        </Badge>
      </button>
    </Popover>
  );
}
